<template>
  <v-card
    id="faulty-meters"
    class="mt-4"
  >
    <v-card-title class="delayed-meters-title">
      <span>Delayed Communication Meters</span>
      <refresh-button
        :loading="isMetersRefreshing"
        @click="refreshMeters()"
      />
    </v-card-title>

    <v-row
      justify="center"
      class="ma-0"
    >
      <v-col
        cols="12"
        md="6"
      >
        <search-input
          v-model="search"
          class="delayed-meters-search pa-0"
          :filters="searchFilters"
          :active-filter="activeSearchFilter"
          @filter-change="onSearchFilterChange"
        />
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      no-data-text="No meters found"
      :items="meters"
      :loading="isMetersLoading"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:progress>
        <v-progress-linear
          indeterminate
          class="mt-2"
          rounded
        ></v-progress-linear>
        <p class="text-center mt-1">
          Loading...Please wait
        </p>
      </template>
      <template v-slot:[`item.account_number`]="{ item }">
        <span
          v-if="item.meter.user"
          class="primary--text font-weight-medium"
        >{{ item.meter.user.account_number }}</span>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <span
          v-if="item.meter.user"
          class="primary--text font-weight-medium"
        >{{ item.meter.user.name }}</span>
      </template>
      <template v-slot:[`item.number`]="{ item }">
        {{ item.meter.number }}
      </template>
      <template v-slot:[`item.last_communication_date`]="{ item }">
        {{ item.meter.last_communication_date | formatDate }}
      </template>
      <template v-slot:[`item.battery_voltage`]="{ item }">
        {{ item.meter.battery_voltage }}
      </template>
      <template v-slot:[`item.signal_intensity`]="{ item }">
        {{ item.meter.signal_intensity }}
      </template>
      <template v-slot:[`item.fault`]="{ item }">
        {{ item.fault_type | formatReason }}
      </template>
    </v-data-table>
    <v-divider />
    <data-table-pagination
      responsive
      :page="pagination.page"
      :page-count="pagination.pageCount"
      @page-change="onPageChange"
      @items-per-page-change="onItemsPerPageChange"
    />
  </v-card>
</template>
<script>
import axios from 'axios'
import _ from 'lodash'
import {
  mdiMagnify, mdiPencil, mdiDelete, mdiClipboardAccount,
} from '@mdi/js'
import SearchInput from '@/components/partials/SearchInput.vue'
import DataTablePagination from '@/components/partials/DataTablePagination.vue'
import RefreshButton from '@/components/partials/RefreshButton.vue'

export default {
  components: {
    SearchInput,
    DataTablePagination,
    RefreshButton,
  },
  filters: {
    formatReason(value) {
      let reason
      switch (value) {
        case 1:
          reason = 'Delayed Communication'

          break
        case 2:
          reason = 'Low Battery'

          break

        default:
          reason = 'Unknown'
          break
      }

      return reason
    },
  },
  data() {
    return {
      sortBy: ['unresolved_mpesa_transactions.created_at'],
      sortDesc: [true],
      showConfirmDeleteDialog: false,
      isConfirmDeleteDialogButtonLoading: false,
      isMetersRefreshing: false,
      search: '',
      pagination: {
        page: 1,
        pageCount: 1,
        itemsPerPage: 10,
      },
      headers: [
        { text: 'Account Number', value: 'account_number' },
        { text: 'Customer', value: 'name' },
        {
          text: 'Meter Number',
          align: 'start',
          value: 'number',
          sortable: false,
        },
        { text: 'Last communication date', value: 'last_communication_date' },
        { text: 'Battery voltage', value: 'battery_voltage' },
        { text: 'Signal intensity', value: 'signal_intensity' },
        { text: 'Fault type', value: 'fault' },
      ],
      activeSearchFilter: 'meters.user.account_number',
      searchFilters: [
        {
          text: 'Account number',
          value: 'meters.user.account_number',
        },
        {
          text: 'Meter number',
          value: 'meters.number',
        },
        {
          text: 'Customer',
          value: 'meters.user.name',
        },
      ],
      icons: {
        mdiMagnify,
        mdiPencil,
        mdiDelete,
        mdiClipboardAccount,
      },
      id: '',
      isMetersLoading: false,
      assignTransactionDialog: false,
      meters: [],
    }
  },
  computed: {
    sortOrder() {
      return this.sortDesc[0] ? 'desc' : 'asc'
    },
    refreshTable() {
      return `${this.search}|${this.sortBy}|${this.sortDesc}`
    },
  },
  watch: {
    refreshTable() {
      this.getFaultyMeters()
    },
    activeSearchFilter() {
      if (this.search !== '') {
        this.getFaultyMeters()
      }
    },
  },
  mounted() {
    this.getFaultyMeters()
  },
  methods: {
    getFaultyMeters: _.debounce(function () {
      this.isMetersLoading = true
      axios
        .get(
          `faulty-meters?sortBy=${this.sortBy[0]}&sortOrder=${this.sortOrder}&search=${this.search}&search_filter=${this.activeSearchFilter}&page=${this.pagination.page}&perPage=${this.pagination.itemsPerPage}`,
        )
        .then(response => {
          this.meters = response.data.data
          this.pagination.page = response.data.current_page
          this.pagination.pageCount = response.data.last_page
          this.pagination.itemsPerPage = response.data.per_page
          this.isMetersLoading = false
          this.isMetersRefreshing = false
        })
        .catch(error => {
          this.isMetersLoading = false
          this.isMetersRefreshing = false
          this.$notification.error(error.response.data.message)
        })
    }, 500),
    refreshMeters() {
      this.isMetersRefreshing = true
      this.getFaultyMeters()
    },
    onPageChange(page) {
      this.pagination.page = page
      this.getFaultyMeters()
    },
    onItemsPerPageChange(itemsPerPage) {
      this.pagination.itemsPerPage = itemsPerPage
      this.getFaultyMeters()
    },
    onSearchFilterChange(filter) {
      this.activeSearchFilter = filter
    },
  },
}
</script>

<style scoped>
.delayed-meters-title {
  gap: 12px;
  justify-content: space-between;
}

.delayed-meters-title > span {
  min-width: 0;
  overflow-wrap: anywhere;
}

@media (max-width: 959px) {
  .delayed-meters-search ::v-deep .v-input {
    width: 100%;
    max-width: 100%;
    flex: 1 1 auto;
    border-radius: 8px !important;
  }

  #faulty-meters ::v-deep .v-data-table__mobile-row__cell {
    min-width: 0;
    overflow-wrap: anywhere;
  }
}

.invalidAccountNumber {
  border-left: 1px solid #ffaa2c;
}
.noMeterReading {
  border-left: 1px solid #ff4c51;
}
.invalidCustomer {
  border-left: 1px solid #ed2cff;
}
</style>
